module.exports = __webpack_public_path__ + "img/menu_banner.4bc969b8.png";